import React from 'react';
import { useState } from 'react';
import { BarChart, Bar, Cell, XAxis, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';
import './PortfolioBarchart.scss';

const PortfolioBarchart = (props) => {
  const { data = [], interval = 0, TooltipComponent = CustomTooltip ,isShowFullDate} = props;
  const [currentIndex, setCurrentIndex] = useState(() => data?.length - 1 || 0);

  return (
    <ResponsiveContainer width='100%' height='100%'>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onMouseMove={(entry) => {
          setCurrentIndex(entry?.activeTooltipIndex || data?.length - 1 || 0);
        }}
      >
        <XAxis dataKey='date' interval={interval} />
        {/* <YAxis /> */}
        <Tooltip content={<TooltipComponent isShowFullDate={isShowFullDate} />} />
        <Bar dataKey='total' fill='#6B464C'>
          {React.Children.toArray(
            data.map((_, index) => {
              return <Cell opacity={currentIndex > 0 ? (index <= currentIndex ? 1 : 0.6) : 1} />;
            })
          )}
        </Bar>
        <ReferenceLine y={0} stroke='#000' />
      </BarChart>
    </ResponsiveContainer>
  );
};

const CustomTooltip = ({ active, payload, label ,isShowFullDate}) => {
  if (active && payload && payload.length) {
    return (
      <div className='custom-tooltip'>
        <div className='custom-tooltip_head'>
          <p className='label'>${getUsCurrencyFormat(Number(payload[0]?.payload?.total || 0))}</p>
          <p className='intro'>{isShowFullDate? payload[0]?.payload?.fullDate : payload[0]?.payload?.date}</p>
        </div>
        <div className='custom-tooltip_body'>
          <p className='price'>
            <span>${getUsCurrencyFormat(payload[0]?.payload?.sharesTotal)}</span> total share gains/losses
          </p>
          <p className='price'>
            <span>${getUsCurrencyFormat(payload[0]?.payload?.dividendTotal)}</span> total dividends received
          </p>
        </div>
      </div>
    );
  }
};

export default PortfolioBarchart;
